import React from 'react';
import { Box } from '@mui/material';
import { colors, shape } from '../../design/tokens';

// Shared surface geometry; content and interactions stay owned by each screen.
export default function AppCard({ kind = 'medication', sx, ...props }) {
    return (
        <Box
            {...props}
            sx={{
                borderRadius: `${shape.cardRadius}px`,
                bgcolor: colors.surface,
                border: `1px solid ${kind === 'medication' ? colors.border : colors.borderNeutral}`,
                boxShadow: 'none',
                ...sx,
            }}
        />
    );
}
